import React from 'react'

const ServicesSection = () => {
  return (
    <div>Services</div>
  )
}

export default ServicesSection